import _ from 'lodash';
import createjs from 'createjs-collection';

import * as fJS from './../cjsRoot/fJS';
import { cjsDnD } from './cjsDnD';

export class cjsSorting extends cjsDnD {
  _thrownS;
  _idx;
  _posStartSource;

  constructor(obj) {
    super(obj);
    this._thrownS = false;
    this._posStartSource = false;
  }

  stageMouseDown(e, data) {
    let engine = data.engine;
    let stage = data.cjsStage;

    engine.posStart = _.cloneDeep(engine.pos);

    super.stageMouseDown(e, data);
  }

  stageMouseUp(e, data) {
    let engine = data.engine;
    let stage = data.cjsStage;

    if (stage.mousedown !== true || engine._mousedown !== true) {
      e.stopPropagation();
      return;
    }

    if (
      (engine.inLine === false && engine.thrown !== false && fJS.isEqual(engine.thrown, engine.thrownS)) ||
      (engine.inLine === true &&
        (engine.thrown === false ||
          engine.thrown.idGroup !== engine.thrownS.idGroup ||
          fJS.isEqual(engine.thrown, engine.thrownS)))
    ) {
      engine.dropItem();
      engine.stopMove(e);
      return false;
    }

    if (engine.inLine === false && engine.thrown === false) {
      // console.log('DONT INLINE');
      engine.thrown = engine._intersect(true);
    }

    let item = engine._findItem();

    if (item === false && engine.inLine === true) {
      console.log('DONT FIND INLINE');
      engine.dropItem();
      engine.stopMove(e);
      return;
    }

    if (engine.thrown !== false) {
      stage.sounds.play(engine.idGroup + '.' + engine.id + '.mouseup');
    }

    if (item.block === true || engine.thrown === false) {
      console.log('FIND BLOCK: ' + item.id);
      if (item.block !== true && engine.inLine === true) engine.posStart = _.cloneDeep(engine._posStartSource);

      let hS = _.cloneDeep(engine.thrownS);

      if (item.block === true) {
        engine.thrown = false;
      }

      engine.dropItem();
      if (engine.thrownS === false || (item.block === true && engine.inLine === true)) {
        engine.stopMove(e);
        return;
      }

      let h = engine._findItemByHook(engine._clearQueue(), engine);
      if (h === false && !engine.inLine) {
        engine._arrangeQueue(h, hS);
        engine.stopMove(e);
        return;
      }

      if (engine.thrownS !== false) {
        stage.groups[engine.thrownS.idGroup].items[engine.thrownS.idItem].hooks[engine.thrownS.idHook].isBusy = false;
        engine.thrownS = false;
        engine.thrown = false;
      }

      engine._arrangeQueue(h, hS);
      engine.stopMove(e);
      return;
    }

    if (engine.inLine === true) {
      if (engine.moveQueue) {
        engine._moveQueue(item);
      } else {
        engine._switchItem(item);
      }

      engine.stopMove(e);
      return false;
    }

    // console.log(
    //   'WRZUT: ' +
    //     engine.id +
    //     ' TARY: ' +
    //     engine.thrown.idGroup +
    //     ' ' +
    //     (engine.thrownS !== false ? engine.thrownS.idGroup : 'null')
    // );

    let free = engine._checkIsFreeHook();
    if (engine.thrownS === false || engine.thrown.idGroup !== engine.thrownS.idGroup) {
      if (engine.thrownS !== false && free !== false) {
        // console.log('INNY PRZYPADEK - PRZERZUCANIE MIĘDZY TARGETAMI');
        stage.groups[engine.thrownS.idGroup].items[engine.thrownS.idItem].hooks[engine.thrownS.idHook].isBusy = false;
      }
      // console.log('PRZERZUCANIE MIĘDZY TARGETAMI');
      if (free !== false) {
        let target = stage.groups[engine.thrown.idGroup].items[engine.thrown.idItem];
        engine.thrownS = {
          idGroup: engine.thrown.idGroup,
          idItem: engine.thrown.idItem,
          idHook: free.id,
        };

        if (target.hooks[engine.thrown.idHook].isBusy === true) {
          // console.log('WEPCHNIĘCIE');
          engine._moveQueue(item, true);
        } else {
          // console.log('WOLNA KOTWICA');
          engine._setToPositionHook(free);
        }
        target.hooks[free.id].isBusy = true;
      } else if (engine.thrownS === undefined || engine.thrownS === false) {
        // console.log('BRAK WOLNEJ KOTWICY I BRAK STARTU');
        engine.dropItem();
      } else {
        // console.log('ZAMIANA ELEMENTÓW W RÓŻNYCH TARGETACH');
        engine._switchItem(item);
      }

      engine.stopMove(e);
      return false;
    }

    // console.log('PRZERZUCANIE: ' + engine.id + ' TEN SAM TARGET');
    // console.log('TEN SAM TARGET I INNA KOTWICA');
    if (engine.moveQueue === true) {
      // console.log('KOLEJKA');
      engine._moveQueue(item);
    } else {
      if (item !== false && item.thrownS !== false && engine.thrownS !== false) {
        // console.log('ZAMIANA');
        engine._switchItem(item);
        stage.groups[engine.thrownS.idGroup].items[engine.thrownS.idItem].hooks[engine.thrownS.idHook].isBusy = true;
        stage.groups[item.thrownS.idGroup].items[item.thrownS.idItem].hooks[item.thrownS.idHook].isBusy = true;
      } else {
        if (engine.thrownS.idGroup === engine.thrown.idGroup && engine.thrownS.idItem === engine.thrown.idItem) {
          // console.log('WYCIĄGNIĘCIE ZE ŚRODKA I WRZUCONE NA KONIEC');
          let hS = _.cloneDeep(engine.thrownS),
            h = engine._findItemByHook(engine._clearQueue(), engine);
          engine._arrangeQueue(h, hS);
          engine._setToPositionHook(engine._checkIsFreeHook());

          engine.stopMove(e);
          return false;
        } else {
          // console.log('WYCIĄGNIĘCIE ZE ŚRODKA I WRZUCONE DO INNEGO TARGETU/ITEMU');
          if (free !== false) {
            let hS = _.cloneDeep(engine.thrownS),
              hN = _.cloneDeep(engine.thrown),
              h = engine._findItemByHook(engine._clearQueue(), engine);
            engine._arrangeQueue(h, hS);
            engine.thrown = hN;
            engine._setToPositionHook(free);
          } else {
            // console.log('BRAK WOLNYCH MIEJSC');
          }
        }
      }
    }

    engine.stopMove(e);
  }

  get moveQueue() {
    return typeof this.otherProperty.moveQueue === 'boolean'
      ? this.otherProperty.moveQueue
      : this._stage.defConfig.sorting.moveQueue;
  }

  set posStart(v) {
    this._posStart = v;
  }
  get posStart() {
    return this._posStart;
  }
  get thrownS() {
    return this._thrownS;
  }
  set thrownS(v) {
    this._thrownS = v;
  }
  get idx() {
    return this._idx;
  }
  set idx(v) {
    this._idx = v;
  }

  _findItem() {
    let find = Object.values(this._stage.groups)
      .filter((group) => (this.inLine && group.id === this.idGroup) || !this.inLine)
      .flatMap((group) => Object.values(group.items))
      .find((item) => fJS.isEqual(item.thrownS, this.thrown));

    return typeof find == 'undefined' || find == null ? false : find;
  }

  dropItem() {
    super.dropItem();
    this.thrown = _.cloneDeep(this.thrownS);
    if (this.thrown != false)
      this._stage.groups[this.thrown.idGroup].items[this.thrown.idItem].hooks[this.thrown.idHook].isBusy = true;
  }

  _switchItem(item) {
    let sw1 = this._stage.groups[this.thrown.idGroup].items[this.thrown.idItem].hooks[this.thrown.idHook],
      sw2 = this._stage.groups[this.thrownS.idGroup].items[this.thrownS.idItem].hooks[this.thrownS.idHook],
      swPt1 = sw1.container.localToLocal(0, 0, this.container),
      swPt2 = sw2.container.localToLocal(0, 0, item.container),
      thrownS = _.cloneDeep(this.thrownS);

    this._stage.groups[this.thrown.idGroup].items[this.thrown.idItem].isCorrect = false;
    this._stage.groups[this.thrownS.idGroup].items[this.thrownS.idItem].isCorrect = false;

    this.pos.x = this.x + swPt1.x + sw1.padding.left;
    this.pos.y = this.y + swPt1.y + sw1.padding.top;
    this.thrownS = _.cloneDeep(this.thrown);

    item.pos.x = item.x + swPt2.x + sw2.padding.left;
    item.pos.y = item.y + swPt2.y + sw2.padding.top;
    item.thrownS = _.cloneDeep(thrownS);
    item.thrown = _.cloneDeep(thrownS);

    this.container.parent.setChildIndex(this.container, this.container.parent.getNumChildren() - 1);
    item.container.parent.setChildIndex(item.container, item.container.parent.getNumChildren() - 1);

    this._stage.movesTo.push(this);
    this._stage.movesTo.push(item);

    this.isCorrect = false;
    item.isCorrect = false;
  }

  _moveQueue(item) {
    let queque = [],
      F = this._stage.groups[item.thrownS.idGroup].items[item.thrownS.idItem].hooks[item.thrownS.idHook].idx,
      S = this._stage.groups[this.thrownS.idGroup].items[this.thrownS.idItem].hooks[this.thrownS.idHook].idx,
      S1 = this._stage.groups[this.thrownS.idGroup].items[this.thrownS.idItem].hooks[this.thrownS.idHook].idx,
      flg = Object.keys(this._stage.groups[item.thrownS.idGroup].items[item.thrownS.idItem].hooks).length,
      inc = S > F ? -1 : 1;
    // console.log('S: ' + S + ' F: ' + F + ' inc: ' + inc + ' flg: ' + flg);
    do {
      // console.log('FLG: ' + flg + ' id: ' + item.id);
      let c1 = this._findItemByHook(S1, item);
      S += inc;
      let c2 = this._findItemByHook(S, item);

      if (c2 === false) continue;

      if (c2.block !== true) {
        c2.thrown = _.cloneDeep(c1.thrownS);
        queque.push(c2);
        S1 = _.cloneDeep(S);
      }

      flg--;
    } while (S !== F && flg > 0);

    queque.push(this);

    this._movesQueue(queque);
  }

  _clearQueue() {
    let queque = [],
      S = this._stage.groups[this.thrownS.idGroup].items[this.thrownS.idItem].hooks[this.thrownS.idHook].idx + 1,
      S1 = this._stage.groups[this.thrownS.idGroup].items[this.thrownS.idItem].hooks[this.thrownS.idHook].idx;

    for (
      S = this._stage.groups[this.thrownS.idGroup].items[this.thrownS.idItem].hooks[this.thrownS.idHook].idx + 1;
      S < Object.keys(this._stage.groups[this.thrownS.idGroup].items[this.thrownS.idItem].hooks).length;
      S++
    ) {
      let c1 =
        S === this._stage.groups[this.thrownS.idGroup].items[this.thrownS.idItem].hooks[this.thrownS.idHook].idx + 1
          ? this
          : this._findItemByHook(S1, this);
      let c2 = this._findItemByHook(S, this);

      if (c2 === false) {
        break;
      }

      if (c2.block !== true) {
        c2.thrown = _.cloneDeep(c1.thrownS);
        queque.push(c2);
        S1 = _.cloneDeep(S);
      }
    }

    this._movesQueue(queque);
    S1--;
    // console.log('S: ' + S + ' S1: ' + S1);
    return S1;
  }

  _arrangeQueue(h, hS) {
    if (!(typeof h === 'object' && h !== null)) {
      return;
    }

    Object.values(this._stage.groups[hS.idGroup].items[hS.idItem].hooks).map((hook) => {
      let h1 = this._findItemByHook(hook.idx, { thrownS: hS });
      if (h1 === false) {
        hook.isBusy = false;
      } else {
        h1.thrown = {
          idGroup: hS.idGroup,
          idItem: hS.idItem,
          idHook: hook.id,
        };
        this._stage.groups[h1.idGroup].items[h1.idItem].thrownS = {
          idGroup: hS.idGroup,
          idItem: hS.idItem,
          idHook: hook.id,
        };
        hook.isBusy = true;
      }
    });
  }

  _movesQueue(queque) {
    let q1 = [];
    Object.values(queque).forEach((item) => {
      let hook = this._stage.groups[item.thrown.idGroup].items[item.thrown.idItem].hooks[item.thrown.idHook],
        pt = hook.container.localToLocal(0, 0, item.container);

      item.pos.x = item.x + pt.x + hook.padding.left;
      item.pos.y = item.y + pt.y + hook.padding.top;

      item.thrownS = _.cloneDeep(item.thrown);
      q1.push(item);
    });

    this._stage.movesTo = this._stage.movesTo.concat(q1);
  }

  _findItemByHook(Hidx, target) {
    let find;
    Object.values(this._stage.groups[target.thrownS.idGroup].items[target.thrownS.idItem].hooks)
      .filter((hook) => hook.idx == Hidx)
      .flatMap((hook) => {
        find = Object.values(this._stage.groups)
          .flatMap((group) => Object.values(group.items))
          .filter((item) => typeof item.thrownS != 'undefined' && item.thrownS != null && item.thrownS != false)
          .find((item) => {
            return (
              item.thrownS.idGroup == target.thrownS.idGroup &&
              Object.keys(item.hooks).length == 0 &&
              item.thrownS.idItem == target.thrownS.idItem &&
              item.thrownS.idHook == hook.id
            );
          });
      });

    return typeof find == 'undefined' || find == null ? false : find;
  }

  _checkIsFreeHook() {
    if (this.thrown === false || typeof this.thrown.idGroup !== 'string' || typeof this.thrown.idItem !== 'string') {
      return false;
    }

    let find = Object.values(this._stage.groups[this.thrown.idGroup].items[this.thrown.idItem].hooks).find(
      (hook) => hook.isBusy === false
    );

    return typeof find == 'undefined' || find == null ? false : find;
  }

  _setToPositionHook(hook) {
    this.thrown = { idGroup: hook.idGroup, idItem: hook.idItem, idHook: hook.id };
    this.thrownS = _.cloneDeep(this.thrown);

    let pt = hook.container.localToLocal(0, 0, this.container);
    hook.isBusy = true;
    this.pos.x = this.x + pt.x + hook.padding.left;
    this.pos.y = this.y + pt.y + hook.padding.top;

    this._stage.movesTo.push(this);
  }
}

cjsSorting.afterLoadSamples = function (stage) {
  stage._removeInCorrects = true;
  Object.values(stage.groups)
    .flatMap((group) => Object.values(group.items))
    .flatMap((item) => {
      item.posStart = _.cloneDeep(item.pos);
      if (item._posStartSource === false) item._posStartSource = _.cloneDeep(item.pos);
      Object.values(stage.groups)
        .filter((group1) => group1.id != item.idGroup)
        .flatMap((group1) => Object.values(group1.items))
        .filter((item1) => Object.keys(item1.hooks).length > 0)
        .flatMap((item1) => Object.values(item1.hooks))
        .filter((hook) => {
          let pt = hook.container.localToLocal(0, 0, item.container);
          return item.pos.x === item.x + pt.x && item.pos.y === item.y + pt.y;
        })
        .map((hook) => {
          item.thrown = { idGroup: hook.idGroup, idItem: hook.idItem, idHook: hook.id };
          item.thrownS = { idGroup: hook.idGroup, idItem: hook.idItem, idHook: hook.id };
          hook.isBusy = true;
        });
    });
};

cjsSorting.checkGameAction = function (stage) {
  console.log('cjsSorting CHECK');
  Object.values(stage.groups)
    .flatMap((group) => Object.values(group.items))
    .flatMap((item) => (item.posStart = _.cloneDeep(item.pos)));

  let isCorrect = cjsDnD.checkGameAction(stage);

  if (isCorrect === false) {
    Object.values(stage.groups)
      .flatMap((group) => Object.values(group.items))
      .filter((item) => {
        if (!(item.correct.length > 0)) item.isCorrect = false;
        return item.correct.length > 0;
      })
      .flatMap((item) => {
        item.isCorrect = !Object.values(item.correct).some(
          (correct) => stage.groups[correct.idGroup].items[correct.idItem].isCorrect !== true
        );
      });

    isCorrect = !Object.values(stage.groups)
      .flatMap((group) => Object.values(group.items))
      .some((item) => {
        if (!(item.isCorrect === false) && stage.correctBlock === true) item.block = true;
        return item.isCorrect === false;
      });
  }

  cjsSorting.afterLoadSamples(stage);

  return isCorrect;
};
